import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import AppRoutes from './routes/AppRoutes';
import { setupCSP } from './utils/security';
import './App.css';

function App() {
  useEffect(() => {
    // Setup Content Security Policy
    if (process.env.NODE_ENV === 'production') {
      setupCSP();
    }
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <div className="floating-shapes">
              <div className="floating-shape"></div>
              <div className="floating-shape"></div>
              <div className="floating-shape"></div>
              <div className="floating-shape"></div>
              <div className="sparkle"></div>
              <div className="sparkle"></div>
              <div className="sparkle"></div>
            </div>
            <AppRoutes />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
